import { useQuery } from '@apollo/client';
import { AsOfDate, Portfolio } from '@bakerweb/models';
import { GET_AS_OF_DATES } from '../graphql/queries/getAsOfDates';

export type Data = Pick<
  AsOfDate,
  | 'asOfDate'
  | 'totalAssets'
  | 'totalCapital'
  | 'totalTier1Capital'
  | 'totalRiskBasedAssets'
  | 'taxesStateRate'
  | 'taxesFedRate'
  | 'taxesCostOfFunds'
  | 'modifiedDt'
>;

export const useGetAsOfDates = (portfolio?: Pick<Portfolio, 'portfolioId' | 'institutionId'>) => {
  const portfolioId = portfolio?.portfolioId;
  const institutionId = portfolio?.institutionId;

  const { data, loading, error } = useQuery<{ asOfDates: Data[] }>(GET_AS_OF_DATES, {
    variables: { portfolioId, institutionId },
    skip: !portfolio,
    fetchPolicy: 'cache-first'
  });

  const getAsOfDate = (asOfDate: string) => {
    const foundAsOfDate = data?.asOfDates.find((a) => a.asOfDate === asOfDate);

    if (foundAsOfDate) {
      const {
        totalAssets,
        totalCapital,
        totalRiskBasedAssets,
        totalTier1Capital,
        taxesStateRate,
        taxesFedRate,
        taxesCostOfFunds,
        modifiedDt
      } = foundAsOfDate;

      return {
        totalAssets: totalAssets ? parseInt(totalAssets) : undefined,
        totalCapital: totalCapital ?? undefined,
        totalRiskBasedAssets: totalRiskBasedAssets ?? undefined,
        totalTier1Capital: totalTier1Capital ?? undefined,
        taxesCostOfFunds: taxesCostOfFunds ?? undefined,
        taxesStateRate: taxesStateRate ?? undefined,
        taxesFedRate: taxesFedRate ?? 0,
        modifiedDt
      };
    }

    return {
      totalAssets: undefined,
      totalCapital: undefined,
      totalRiskBasedAssets: undefined,
      totalTier1Capital: undefined,
      taxesCostOfFunds: undefined,
      taxesStateRate: undefined,
      taxesFedRate: 0
    };
  };

  return { loading, error, asOfDates: data?.asOfDates ?? [], getAsOfDate };
};
